module.exports = __webpack_public_path__ + "static/img/1.9646a93a.png";